import { postOneTimeCodeCreate } from '@/api/postOneTimeCodeCreate';
import { AddressTracker } from '@/components/analytics/AddressTracker';

// window.openがsafariで効かないので、location.hrefを用いて遷移
export const goMainOneTimeAuth = async ({
  redirectPath = '/',
  token,
  lotteryEventId,
  shouldTrack = false,
}: {
  redirectPath?: string;
  token?: string;
  lotteryEventId?: number;
  shouldTrack?: boolean;
}) => {
  if (!process.env.NEXT_PUBLIC_SERVICE_ID) return;

  // 住所登録関連の処理の場合のみトラッキング
  if (shouldTrack) {
    AddressTracker.trackStart('one_time_auth', lotteryEventId);
  }

  const { result } = await postOneTimeCodeCreate({
    oemServiceId: process.env.NEXT_PUBLIC_SERVICE_ID,
    token: token,
  });
  const url = `${process.env.NEXT_PUBLIC_MAIN_URL}/one-time-auth?code=${result.authCode}&redirect_path=${redirectPath}`;

  // 住所登録関連の処理の場合のみトラッキング
  if (shouldTrack) {
    AddressTracker.trackExternalRedirect(url, lotteryEventId);
  }

  location.href = url;
};

export { locationHref, pickErrorMessages, scrollIntoTheView } from '@monorepo/common';
